import React, { useState } from "react";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { useDispatch, useSelector } from "react-redux";
import "../NTFS/ntfs.scss";
import {
  SET_DEFENDER_ENABLED,
  SET_DEFENDER_SAME_AS_SENTINEL,
  SET_DEFENDER_AZURE_TENANT_ID,
  SET_DEFENDER_CLIENT_ID,
  SET_DEFENDER_CLIENT_SECRET,
} from "../../../redux/constants/constants";
import DynamicFormField from "../NTFS/DynamicFormField";

const MSDefenderConfiguration = ({ errorObj, setErrorObj }) => {
  const dispatch = useDispatch();

  const {
    defenderEnabled,
    defenderSameAsSentinel,
    defenderAzureTenantId,
    defenderClientId,
    defenderClientSecret,
  } = useSelector((state) => state.tenantSignUpReducer);

  // local state for the eye/reveal icons
  const [showTenant, setShowTenant] = useState(false);
  const [showClientId, setShowClientId] = useState(false);
  const [showClientSecret, setShowClientSecret] = useState(false);

  const toggleTenantVisibility = () => setShowTenant((prev) => !prev);
  const toggleClientIdVisibility = () => setShowClientId((prev) => !prev);
  const toggleClientSecretVisibility = () => setShowClientSecret((prev) => !prev);

  // ON/OFF toggle for the whole Defender section
  const handleDefenderEnabledChange = () => {
    dispatch({
      type: SET_DEFENDER_ENABLED,
      payload: !defenderEnabled,
    });
  };

  // "Use same configuration as Microsoft Sentinel" checkbox
  const handleSameAsSentinelChange = () => {
    dispatch({
      type: SET_DEFENDER_SAME_AS_SENTINEL,
      payload: !defenderSameAsSentinel,
    });
  };

  const handleTenantChange = (e) => {
    dispatch({
      type: SET_DEFENDER_AZURE_TENANT_ID,
      payload: e.target.value,
    });
  };

  const handleClientIdChange = (e) => {
    dispatch({
      type: SET_DEFENDER_CLIENT_ID,
      payload: e.target.value,
    });
  };

  const handleClientSecretChange = (e) => {
    dispatch({
      type: SET_DEFENDER_CLIENT_SECRET,
      payload: e.target.value,
    });
  };

  return (
    <div className="ntfsMainContainer">
    {/* Header row: title + ON/OFF toggle — matches NTFS */}
      <div className="selectiveUsers platformNTFS defenderHeaderRow">
        <span className="selectiveUserText platformNTFS">Microsoft Defender Configuration</span>
        <FormControlLabel
          control={
            <Switch
              checked={defenderEnabled}
              onChange={handleDefenderEnabledChange}
              color="primary"
            />
          }
        />
      </div>

      {/* Everything below only shows when the toggle is ON */}
      {defenderEnabled && (
        <>
          {/* "Same as Sentinel" checkbox */}
          <div className="defenderSameConfigRow">
            <input
              type="checkbox"
              checked={defenderSameAsSentinel}
              onChange={handleSameAsSentinelChange}
            />
            <div>
              <div className="defenderSameConfigTitle">
                Use same configuration as Microsoft Sentinel
              </div>
              <div className="defenderSameConfigSubtext">
                Uses the same app registration and tenant
              </div>
            </div>
          </div>

          {/* Defender fields only show when the checkbox is UNCHECKED */}
          {!defenderSameAsSentinel && (
            <div className="ntfsS3fieldContainer">
              <DynamicFormField
                label="Azure Tenant ID"
                value={defenderAzureTenantId || ""}
                type="password"
                placeholder="Enter Azure Tenant ID"
                onChange={handleTenantChange}
                showPassword={showTenant}
                togglePasswordVisibility={toggleTenantVisibility}
                important={false}
              />

              <DynamicFormField
                label="Client ID"
                value={defenderClientId || ""}
                type="password"
                placeholder="Enter Client ID"
                onChange={handleClientIdChange}
                showPassword={showClientId}
                togglePasswordVisibility={toggleClientIdVisibility}
                important={false}
              />

              <DynamicFormField
                label="Client Secret"
                value={defenderClientSecret || ""}
                type="password"
                placeholder="Enter Client Secret"
                onChange={handleClientSecretChange}
                showPassword={showClientSecret}
                togglePasswordVisibility={toggleClientSecretVisibility}
                important={false}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default MSDefenderConfiguration;